/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";

// ─── Renk sabitleri ──────────────────────────────────────────────────────────
const C = {
    long:    "#16a34a",
    short:   "#dc2626",
    bg:      "#0f172a",
    panel:   "#1e293b",
    border:  "#334155",
    text:    "#e2e8f0",
    muted:   "#94a3b8",
    accent:  "#3b82f6",
    warning: "#f59e0b",
    gold:    "#eab308",
    purple:  "#7c3aed",
};

const DURUM_STIL = {
    bekliyor:      { bg: "#1e3a5f", renk: "#60a5fa",   etiket: "⏳ Bekliyor"      },
    tetiklendi:    { bg: "#14532d", renk: "#4ade80",   etiket: "✅ Tetiklendi"    },
    suresi_doldu:  { bg: "#1c1917", renk: "#6b7280",   etiket: "⏰ Süresi Doldu"  },
};

// ─── Token yardımcı ─────────────────────────────────────────────────────────
async function getToken() {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return null;
    if (session.expires_at * 1000 - Date.now() < 5 * 60 * 1000) {
        const { data } = await supabase.auth.refreshSession();
        return data.session?.access_token;
    }
    return session.access_token;
}

// ─── Cascade Plan Kartı ──────────────────────────────────────────────────────
function CascadePlanKart({ plan, trend }) {
    if (!plan) return null;
    const isLong = trend === "LONG";
    const c      = isLong ? C.long : C.short;

    const PlanSatir = ({ etiket, deger, pct, rr, vurgu }) => (
        <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "6px 0", borderBottom: `1px solid ${C.border}`,
        }}>
            <span style={{ fontSize: 12, color: C.muted }}>{etiket}</span>
            <div style={{ textAlign: "right" }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: vurgu || C.text }}>
                    {deger}
                </span>
                {pct  && <span style={{ fontSize: 10, color: C.muted, marginLeft: 6 }}>%{pct}</span>}
                {rr   && <span style={{ fontSize: 10, color: C.gold,  marginLeft: 6 }}>R:R 1:{rr}</span>}
            </div>
        </div>
    );

    return (
        <div style={{
            background: "#0a0f1e", border: `1px solid ${c}44`,
            borderRadius: 10, padding: "14px 16px", marginTop: 12,
        }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: c, marginBottom: 10 }}>
                {isLong ? "📈" : "📉"} Cascade Plan — {trend}
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" }}>
                {/* Sol: Giriş */}
                <div>
                    <div style={{ fontSize: 10, color: C.muted, fontWeight: 700, marginBottom: 6,
                        textTransform: "uppercase", letterSpacing: "0.06em" }}>
                        📥 Giriş Kademeleri
                    </div>
                    <PlanSatir etiket="Kademe-1" deger={plan.kademe_1} pct={plan.kademe_1_pct} />
                    <PlanSatir etiket="Kademe-2" deger={plan.kademe_2} pct={plan.kademe_2_pct} />
                    <PlanSatir etiket="Kademe-3" deger={plan.kademe_3} pct={plan.kademe_3_pct} />
                    <PlanSatir etiket="Ort. Giriş" deger={plan.ort_giris} vurgu={c} />
                </div>

                {/* Sağ: Stop + TP */}
                <div>
                    <div style={{ fontSize: 10, color: C.muted, fontWeight: 700, marginBottom: 6,
                        textTransform: "uppercase", letterSpacing: "0.06em" }}>
                        🛑 Stop Loss &amp; Çıkış
                    </div>
                    <PlanSatir etiket="Stop Loss" deger={plan.stop_loss} vurgu={C.short} />
                    <PlanSatir etiket={`Risk (%${plan.risk_pct})`} deger={plan.risk} />
                    <PlanSatir etiket="TP-1" deger={plan.tp1} pct={plan.tp1_pct} rr={plan.rr_tp1} vurgu={C.long} />
                    <PlanSatir etiket="TP-2" deger={plan.tp2} pct={plan.tp2_pct} rr={plan.rr_tp2} vurgu={C.long} />
                    <PlanSatir etiket={`TP-3 (%${plan.tp3_pct})`} deger="Trailing Stop" vurgu={C.gold} />
                </div>
            </div>
        </div>
    );
}

// ─── İzleme Kartı ─────────────────────────────────────────────────────────────
function IzlemeKart({ item, onSil, siliniyor }) {
    const [detayAcik, setDetayAcik] = useState(false);
    const isLong    = item.trend_yonu === "LONG";
    const trenRenk  = isLong ? C.long : C.short;
    const durumStil = DURUM_STIL[item.durum] || DURUM_STIL.bekliyor;

    const kalanesure = () => {
        if (!item.ekleme_zamani) return null;
        const ekleme = new Date(item.ekleme_zamani);
        const bitis  = new Date(ekleme.getTime() + 24 * 60 * 60 * 1000);
        const kalan  = Math.max(0, bitis - Date.now());
        const saat   = Math.floor(kalan / 3600000);
        const dakika = Math.floor((kalan % 3600000) / 60000);
        if (kalan === 0) return "Süresi doldu";
        return `${saat}s ${dakika}dk kaldı`;
    };

    return (
        <div style={{
            background: C.panel, border: `1px solid ${
                item.durum === "tetiklendi" ? trenRenk + "88" : C.border
            }`,
            borderRadius: 12, padding: "16px 20px", marginBottom: 12,
            boxShadow: item.durum === "tetiklendi" ? `0 0 12px ${trenRenk}22` : "none",
        }}>
            {/* Üst Satır */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                {/* Trend rozeti */}
                <span style={{
                    background: trenRenk + "22", color: trenRenk,
                    border: `1px solid ${trenRenk}`,
                    borderRadius: 6, padding: "4px 12px",
                    fontSize: 12, fontWeight: 700,
                }}>
                    {isLong ? "📈 LONG" : "📉 SHORT"}
                </span>

                {/* Sembol */}
                <span style={{ fontSize: 16, fontWeight: 800, color: C.text }}>
                    {item.symbol}
                </span>

                {/* Mod */}
                <span style={{ fontSize: 11, color: C.muted, background: "#0f172a",
                    padding: "2px 8px", borderRadius: 4 }}>
                    {item.mod}
                </span>

                {/* Durum */}
                <span style={{
                    background: durumStil.bg, color: durumStil.renk,
                    border: `1px solid ${durumStil.renk}44`,
                    borderRadius: 20, padding: "3px 12px",
                    fontSize: 12, fontWeight: 600,
                }}>
                    {durumStil.etiket}
                </span>

                {/* LTF Periyot (tetiklendiyse) */}
                {item.ltf_periyot && (
                    <span style={{ fontSize: 11, color: C.gold, background: "#1a1500",
                        padding: "2px 8px", borderRadius: 4, border: `1px solid ${C.gold}44` }}>
                        {item.ltf_periyot} MSS
                    </span>
                )}

                {/* Spacer */}
                <div style={{ flex: 1 }} />

                {/* Kalan süre */}
                {item.durum === "bekliyor" && (
                    <span style={{ fontSize: 11, color: C.muted }}>⏱ {kalanesure()}</span>
                )}

                {/* Detay / Gizle */}
                <button onClick={() => setDetayAcik(!detayAcik)} style={{
                    background: "none", border: `1px solid ${C.border}`,
                    color: C.muted, borderRadius: 6, padding: "4px 12px",
                    fontSize: 11, cursor: "pointer",
                }}>
                    {detayAcik ? "▲ Gizle" : "▼ Detay"}
                </button>

                {/* Sil */}
                <button
                    onClick={() => onSil(item.id)}
                    disabled={siliniyor === item.id}
                    title="İzleme listesinden sil"
                    style={{
                        background: "#7f1d1d22", border: `1px solid ${C.short}44`,
                        color: C.short, borderRadius: 6, padding: "4px 10px",
                        fontSize: 12, cursor: "pointer",
                        opacity: siliniyor === item.id ? 0.5 : 1,
                    }}
                >
                    🗑
                </button>
            </div>

            {/* Özet Bilgiler */}
            <div style={{ display: "flex", gap: 20, marginTop: 10, flexWrap: "wrap" }}>
                <div style={{ fontSize: 12, color: C.muted }}>
                    Eklenme: <span style={{ color: C.text }}>
                        {new Date(item.ekleme_zamani).toLocaleString("tr-TR")}
                    </span>
                </div>
                {item.son_kontrol && (
                    <div style={{ fontSize: 12, color: C.muted }}>
                        Son Kontrol: <span style={{ color: C.text }}>
                            {new Date(item.son_kontrol).toLocaleString("tr-TR")}
                        </span>
                    </div>
                )}
                {item.anlik_fiyat && (
                    <div style={{ fontSize: 12, color: C.muted }}>
                        Eklenme Fiyatı: <span style={{ color: C.text }}>{item.anlik_fiyat}</span>
                    </div>
                )}
            </div>

            {/* Detay Açıldığında */}
            {detayAcik && (
                <div style={{ marginTop: 14 }}>
                    {/* Sweep Verisi */}
                    {item.sweep_data && (
                        <div style={{
                            background: "#0a0f1e", border: `1px solid ${C.border}`,
                            borderRadius: 8, padding: "12px 14px", marginBottom: 8,
                        }}>
                            <div style={{ fontSize: 11, color: C.warning, fontWeight: 700, marginBottom: 8 }}>
                                ⚡ Aşama 2 — 4H Sweep Verisi
                            </div>
                            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 12 }}>
                                {isLong ? (
                                    <>
                                        <span><span style={{ color: C.muted }}>SSL:</span>
                                            <strong style={{ color: C.text, marginLeft: 4 }}>{item.sweep_data.swing_low}</strong></span>
                                        <span><span style={{ color: C.muted }}>İğne Dibi:</span>
                                            <strong style={{ color: C.short, marginLeft: 4 }}>{item.sweep_data.sweep_wick}</strong></span>
                                    </>
                                ) : (
                                    <>
                                        <span><span style={{ color: C.muted }}>BSL:</span>
                                            <strong style={{ color: C.text, marginLeft: 4 }}>{item.sweep_data.swing_high}</strong></span>
                                        <span><span style={{ color: C.muted }}>İğne Tepesi:</span>
                                            <strong style={{ color: C.long, marginLeft: 4 }}>{item.sweep_data.sweep_wick}</strong></span>
                                    </>
                                )}
                                <span><span style={{ color: C.muted }}>Fitil:</span>
                                    <strong style={{ color: C.gold, marginLeft: 4 }}>%{item.sweep_data.fitil_pct}</strong></span>
                                <span><span style={{ color: C.muted }}>Sweep Zamanı:</span>
                                    <strong style={{ color: C.text, marginLeft: 4 }}>
                                        {item.sweep_data.sweep_zamani
                                            ? new Date(item.sweep_data.sweep_zamani).toLocaleString("tr-TR")
                                            : "—"}
                                    </strong>
                                </span>
                            </div>
                        </div>
                    )}

                    {/* MSS Verisi (tetiklendiyse) */}
                    {item.mss_data && (
                        <div style={{
                            background: "#0a0f1e", border: `1px solid ${C.long}44`,
                            borderRadius: 8, padding: "12px 14px", marginBottom: 8,
                        }}>
                            <div style={{ fontSize: 11, color: C.long, fontWeight: 700, marginBottom: 8 }}>
                                ✅ Aşama 3 — {item.ltf_periyot} MSS Tetiklendi
                            </div>
                            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 12 }}>
                                <span><span style={{ color: C.muted }}>
                                    {isLong ? "Kırılan LH:" : "Kırılan HL:"}
                                </span>
                                    <strong style={{ color: trenRenk, marginLeft: 4 }}>
                                        {item.mss_data.lh_seviye || item.mss_data.hl_seviye}
                                    </strong>
                                </span>
                                <span><span style={{ color: C.muted }}>Kırılım Fiyatı:</span>
                                    <strong style={{ color: C.text, marginLeft: 4 }}>{item.mss_data.kirim_fiyat}</strong>
                                </span>
                                <span><span style={{ color: C.muted }}>Hacim Onayı:</span>
                                    <strong style={{ color: item.mss_data.hacim_onay ? C.long : C.short, marginLeft: 4 }}>
                                        {item.mss_data.hacim_onay ? "✅" : "❌"}
                                    </strong>
                                </span>
                                <span><span style={{ color: C.muted }}>Zaman:</span>
                                    <strong style={{ color: C.text, marginLeft: 4 }}>
                                        {item.mss_data.mss_zamani
                                            ? new Date(item.mss_data.mss_zamani).toLocaleString("tr-TR")
                                            : "—"}
                                    </strong>
                                </span>
                            </div>
                        </div>
                    )}

                    {/* Cascade Plan */}
                    <CascadePlanKart plan={item.cascade_plan} trend={item.trend_yonu} />
                </div>
            )}
        </div>
    );
}

// ─── ANA BILEŞEN ─────────────────────────────────────────────────────────────
export default function TopdownIzlemeListesi() {
    const [liste,      setListe]      = useState([]);
    const [yukleniyor, setYukleniyor] = useState(true);
    const [siliniyor,  setSiliniyor]  = useState(null);
    const [filtre,     setFiltre]     = useState("hepsi"); // hepsi | bekliyor | tetiklendi | suresi_doldu

    const yukle = async () => {
        setYukleniyor(true);
        try {
            const token = await getToken();
            const res   = await axios.get(`${API_URL}/topdown-watchlist/listele`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setListe(res.data.liste || []);
        } catch (e) {
            toast.error("Liste yüklenemedi: " + (e.response?.data?.detail || e.message));
        } finally {
            setYukleniyor(false);
        }
    };

    useEffect(() => { yukle(); }, []);

    // 30 saniyede bir yenile (tetiklenme anında anlık güncelleme için)
    useEffect(() => {
        const id = setInterval(yukle, 30000);
        return () => clearInterval(id);
    }, []);

    const sil = async (id) => {
        setSiliniyor(id);
        try {
            const token = await getToken();
            await axios.delete(`${API_URL}/topdown-watchlist/sil/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setListe(prev => prev.filter(i => i.id !== id));
            toast.success("İzleme listesinden silindi");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Silinemedi");
        } finally {
            setSiliniyor(null);
        }
    };

    // Filtrelenmiş liste
    const filtrelenmis = filtre === "hepsi"
        ? liste
        : liste.filter(i => i.durum === filtre);

    const say = (d) => liste.filter(i => i.durum === d).length;

    return (
        <div style={{ background: C.bg, minHeight: "100vh", padding: "24px",
            fontFamily: "system-ui, sans-serif" }}>

            {/* Başlık */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20,
                flexWrap: "wrap" }}>
                <div>
                    <h1 style={{ color: C.text, fontSize: 22, fontWeight: 800, margin: 0 }}>
                        👁 Topdown Cascade İzleme Listesi
                    </h1>
                    <p style={{ color: C.muted, fontSize: 13, margin: "4px 0 0" }}>
                        5 dakikada bir Aşama 3 (MSS) otomatik kontrol edilir.
                        Tetiklenirse Cascade Planı burada görünür ve bildirim gönderilir.
                    </p>
                </div>
                <div style={{ flex: 1 }} />
                <button onClick={yukle} style={{
                    padding: "8px 18px", borderRadius: 8,
                    border: `1px solid ${C.border}`, background: "transparent",
                    color: C.muted, cursor: "pointer", fontSize: 13,
                }}>
                    🔄 Yenile
                </button>
            </div>

            {/* Özet */}
            <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
                {[
                    { key: "hepsi",      label: "Tümü",          count: liste.length,        renk: C.accent  },
                    { key: "bekliyor",   label: "⏳ Bekliyor",   count: say("bekliyor"),     renk: "#60a5fa" },
                    { key: "tetiklendi", label: "✅ Tetiklendi", count: say("tetiklendi"),   renk: C.long    },
                    { key: "suresi_doldu", label: "⏰ Süresi Doldu", count: say("suresi_doldu"), renk: C.muted },
                ].map(f => (
                    <button key={f.key} onClick={() => setFiltre(f.key)} style={{
                        padding: "8px 16px", borderRadius: 8,
                        border: `1px solid ${filtre === f.key ? f.renk : C.border}`,
                        background: filtre === f.key ? f.renk + "22" : "transparent",
                        color: filtre === f.key ? f.renk : C.muted,
                        fontWeight: 600, fontSize: 12, cursor: "pointer",
                    }}>
                        {f.label} ({f.count})
                    </button>
                ))}
            </div>

            {/* Bilgi Notu */}
            <div style={{
                background: "#1a1f2e", border: `1px solid ${C.accent}33`,
                borderRadius: 8, padding: "10px 14px", marginBottom: 20,
                fontSize: 12, color: C.muted,
            }}>
                💡 <strong style={{ color: C.accent }}>Nasıl çalışır?</strong>{" "}
                Topdown Cascade Tarama'daki 🔍 emojisine tıklayarak buraya ekleyin.
                24 saat içinde Aşama 3 (MSS) gerçekleşmezse hisse otomatik çıkar.
                Tetiklenirse Aşama 4–6 planı aşağıda gösterilir ve bildirim alırsınız.
            </div>

            {/* Liste */}
            {yukleniyor ? (
                <div style={{ textAlign: "center", padding: 40, color: C.muted }}>
                    ⏳ Yükleniyor...
                </div>
            ) : filtrelenmis.length === 0 ? (
                <div style={{
                    background: C.panel, border: `1px dashed ${C.border}`,
                    borderRadius: 12, padding: 48, textAlign: "center",
                }}>
                    <div style={{ fontSize: 36, marginBottom: 12 }}>👁</div>
                    <div style={{ color: C.muted, fontSize: 15 }}>
                        {filtre === "hepsi"
                            ? "İzleme listesi boş. Topdown Cascade Tarama'dan 🔍 ile ekleyin."
                            : `"${filtre}" durumunda hisse yok.`}
                    </div>
                </div>
            ) : (
                filtrelenmis.map(item => (
                    <IzlemeKart
                        key={item.id}
                        item={item}
                        onSil={sil}
                        siliniyor={siliniyor}
                    />
                ))
            )}
        </div>
    );
}
